import {useCallback, useEffect, useState,} from "react";

import {shouldShowProfileCabinetOnboarding,} from "../../application/user-profile/profile-cabinet-onboarding";
import {browserProfileOnboardingStore,} from "../../infrastructure/user-profile/browser-profile-onboarding-store";

export function useProfileCabinetOnboarding(userId) {
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        const hasSeen =
            browserProfileOnboardingStore
                .hasSeenCabinetLocation(userId);

        setVisible(
            shouldShowProfileCabinetOnboarding({
                userId,
                hasSeen,
            })
        );
    }, [userId]);

    const dismiss = useCallback(() => {
        browserProfileOnboardingStore
            .markCabinetLocationSeen(userId);

        setVisible(false);
    }, [userId]);

    return {
        isVisible,
        dismiss,
    };
}
